<fr-isc-form Id="invite-members" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
</fr-isc-form>
